const notificationAdjustments = () => {
	const bar = document.querySelector('.notifBar__wrap');

	if (bar) {
		// helper function to remove px, turn values into numbers, combine the values, and turn them back into px string
		function combine(px1, px2) {
			let px2Value = parseInt(px2);
			let resultValue = px1 + px2Value;
			let resultPx = resultValue.toString() + 'px';
			return resultPx;
		}

		function updateSearchbarPosition() {
			let windowWidth = window.innerWidth;
			let search = document.querySelector('.searchBar');
			let barHeight = window.getComputedStyle(bar);
			let height = barHeight.getPropertyValue('height');
			let top;
			if (windowWidth > 1010) {
				top = combine(148, height);
			} else if (1010 > windowWidth && windowWidth > 600) {
				top = combine(80, height);
			} else {
				top = combine(59, height);
			}
			search.style.top = top;
		}
		function updateHeaderPadding() {
			let header = document.querySelector('header');
			let headerStyle = window.getComputedStyle(header);
			let padding = headerStyle.getPropertyValue('bottomPadding');
			let top;
			top = combine(1, padding);
			header.style.paddingBottom = top;
		}

		updateHeaderPadding();
		updateSearchbarPosition();

		window.addEventListener('resize', function () {
			updateHeaderPadding();
			updateSearchbarPosition();
		});
	}
};

export default notificationAdjustments;
